import React, {useEffect, useState} from 'react';
import {updateHeader, updateUrl, hideEditProduct} from '../../../store/actions/main';
import {connect} from 'react-redux';
import {updateModellTypeGelaender,
        updateModallTitelGelaender,
        selectImageCategoryGelaender
    } from '../../../store/actions/gelaender';
import ModalPopUp from '../../../module/modalPopUp';
import {StepComponent} from '../../../module/step_component';
import Button from '@material-ui/core/Button';
import ImageSlider from '../../../module/imageSlider';
import {ProductInfo} from '../../../module/productInfo';
import {gelaender_auswahl} from '../../../../assets/images/data';


const Index = (props) => {
    const [showModalStepper, setShowModalStepper] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [showModalImages, setModalImages] = useState(false);
    const [modell_index, setIndexModell] = useState(0);

    const closeModalStepper = () => setShowModalStepper(false);
    const closeModalInfo = () => setShowModalInfo(false);
    const closeModalImages = () => setModalImages(false);

    useEffect(() => {
        updateItems();
    })

    const updateItems = () => {
        props.updateHeader('Geländer');
        // let image_gelaender_wrapper_ohneFuellung = document.querySelectorAll('.image_gelaender_wrapper')[3];

        // if (props.data[3].is_merkliste) {
        //     image_gelaender_wrapper_ohneFuellung.classList.add('check');
        // } else {
        //     image_gelaender_wrapper_ohneFuellung.classList.remove('check');
        // }

       editProduct();

    }

    const editProduct = () => {
        let edit_modell_index = props.main_data[3].editProduct[0].editProductIndex;
        let isEditProduct = props.main_data[3].editProduct[0].isEditProduct;
        let product = document.querySelectorAll('.stepper-button');

        if (isEditProduct) {
            console.log('product', product);
            product[edit_modell_index].click();
            props.hideEditProduct();
        }
   }

    const showStepper = ev => {
        let modell = ev.currentTarget.getAttribute('titel');
        let modell_index = ev.currentTarget.getAttribute('index');
        let urlLocation = ev.target.ownerDocument.location.origin;

        if (modell_index === '3') props.selectImageCategory(urlLocation);

        props.updateUrl(modell);
        props.updateModellTypeGelaender(modell_index);
        props.updateModallTitel(modell);
        setShowModalStepper(true);
    }

    const showInfo = ev => {
        let index = ev.currentTarget.getAttribute('index');
        //props.updateModellIndex(index);
        setIndexModell(Number(index));
        setShowModalInfo(true);
    }

    const showImages = ev => {
        setIndexModell(Number(ev));
        setModalImages(true);
    }

    return (
        <div className='product_main_wrapper'>
             <h2>Welche Geländerart?</h2>
                <div className='product_wrapper'>
                {gelaender_auswahl.map((elem, index) => (
                        <div key={index} className='inner-modell-wrapper-gelaender'>
                            <p className="titel">{elem.titel}</p>
                            <ImageSlider
                                showImages={() => showImages(index)}
                                imageposter={elem.portfolio}
                            />
                            <div className="button-wrapper">
                                <Button onClick={showStepper} titel={elem.titel} index={index} className='button stepper-button'>Konfigurator starten</Button>
                                <Button onClick={showInfo} index={index} className='button info'>Mehr Informationen</Button>
                            </div>
                        </div>
                    ))}
                </div>
                <ModalPopUp
                    title={gelaender_auswahl[modell_index].titel+" - Bilder"}
                    class='modell'
                    component={<ImageSlider showModalImages={showModalImages} imageposter={gelaender_auswahl[modell_index].portfolio} />}
                    showModal={showModalImages}
                    hideModal={closeModalImages}
                />
                <ModalPopUp
                    title={gelaender_auswahl[modell_index].titel}
                    class='modell'
                    component={<StepComponent />}
                    showModal={showModalStepper}
                    hideModal={closeModalStepper}
                />
                <ModalPopUp
                     title={"Produktbeschreibung - "+gelaender_auswahl[modell_index].titel}
                     class='modell'
                     component={<ProductInfo
                                 type={"ein "+gelaender_auswahl[modell_index].titel}
                                 desc={gelaender_auswahl[modell_index].desc}
                                 desc_items={gelaender_auswahl[modell_index].content}
                                 price={`Ab ${gelaender_auswahl[modell_index].price.toFixed(2)}€`}
                                 />}
                     showModal={showModalInfo}
                     hideModal={closeModalInfo}
               />
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.gelaenderReducer.data,
        main_data: state.mainReducer.data
    }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        updateModellTypeGelaender: ev => dispatch(updateModellTypeGelaender(ev)),
        hideEditProduct: () => dispatch(hideEditProduct()),
        updateModallTitel: ev => dispatch(updateModallTitelGelaender(ev)),
        selectImageCategory: ev => dispatch(selectImageCategoryGelaender(ev))
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Index);